import axios from "axios";
import { toastr } from "react-redux-toastr";
import isEmpty from "../../utils/constants/isEmpty";
import Api, { rootUrl } from "../../utils/config/api";
import { getRefreshToken } from "../../utils/constants/checkAuth";
import setTokenInHeader from "../../utils/constants/setTokenInHeader";
import {
  SET_CURRENT_USER,
  SET_SIGNUP_DATA,
  GET_COUNTRIES_DATA,
  SET_USER_FRM_API,
  SET_BILLING_DETAILS,
  RESET_AUTH_STATE,
  SET_STATES_OF_COUNTRY,
} from "../types";
import { resetLoyalty } from "./loyaltyActions";
import { resetCamps, resetCampState } from "./campaignsActions";
import { resetStore } from "./storesAction";
import { initalizeAutoCampState } from "./autoEngageActions";
import { resetGroup } from "./groupsAction";
import { resetChannelState } from "./channelsActions";
import { resetCustState } from "./custInsightActions";
import { resetDashboardState } from "./dashboardActions";
import { resetFbState } from "./feedbackActions";
import { resetVendorState } from "./integrationActions";
import { resetPayState } from "./paymentActions";
import { resetShortlinkState } from "./shortlinkActions";
import { resetOnboardState } from "./userOnboardActions";
import { resetProductTour } from "./productTourActions";
import { existingSeparateAccPerm } from "../../components/Pages/Private/InviteTeamMembers/utils";
import { resetAmplitude } from "../../utils/config/analytics";
import { resetAudienceRecState } from "./audienceRecommendationActions";

export const setInitialSignUpData = (initialData) => (dispatch) => {
  dispatch({
    type: SET_SIGNUP_DATA,
    payload: initialData,
  });
};

export const setCurrentUser = (tokenObj) => (dispatch) => {
  setTokenInHeader(tokenObj?.token);
  dispatch({
    type: SET_CURRENT_USER,
    payload: !isEmpty(tokenObj?.token),
  });
};

export const getCountriesSeed = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get("/v1/seed/countries")
      .then((res) => {
        const countries = res.data.payload?.countries;

        dispatch({
          type: GET_COUNTRIES_DATA,
          payload: countries,
        });

        return resolve(true);
      })
      .catch((err) => reject(err));
  });
};

export const getCurrentUser = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get("/v1/users/me")
      .then((res) => {
        let user = res?.data?.payload;

        if (
          !user?.permissions &&
          !user?.custom_user_id &&
          user?.role?.key === "store_manager"
        )
          user = { ...user, permissions: existingSeparateAccPerm };

        if (
          user?.is_active === false &&
          user?.role?.key?.length > 0 &&
          user?.custom_user_id?.length > 0
        ) {
          dispatch(logoutCall());

          return reject(null);
        }

        dispatch({
          type: SET_USER_FRM_API,
          payload: user,
        });

        return resolve(user);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const storeOutsideIndiaSignups = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/validate-country", data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const signupCall = (data) => (dispatch) => {
  dispatch(resetStore());
  localStorage?.removeItem("storeId");
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/register", data)
      .then((res) => {
        const { tokens, user } = res.data.payload;
        dispatch(setCurrentUser(tokens.access));
        dispatch(setInitialSignUpData(user));
        localStorage?.setItem("accessToken", JSON.stringify(tokens.access));
        localStorage?.setItem("refreshToken", JSON.stringify(tokens.refresh));

        return resolve(user);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const loginCall = (data) => (dispatch) => {
  dispatch(resetStore());
  localStorage?.removeItem("storeId");
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/login-email", data)
      .then((res) => {
        const { tokens, user } = res.data.payload;
        dispatch(setCurrentUser(tokens.access));
        dispatch(setInitialSignUpData(user));
        localStorage.setItem("accessToken", JSON.stringify(tokens.access));
        localStorage.setItem("refreshToken", JSON.stringify(tokens.refresh));

        return resolve(res.data?.payload?.user);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const adminAccess = (data) => (dispatch) => {
  dispatch(clearFeaturesData());
  localStorage?.removeItem("storeId");
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/access/login", data)
      .then((res) => {
        const { tokens, user } = res.data.payload;
        dispatch(setCurrentUser(tokens.access));
        dispatch(setInitialSignUpData(user));
        localStorage.setItem("accessToken", JSON.stringify(tokens.access));
        localStorage.setItem("refreshToken", JSON.stringify(tokens.refresh));

        return resolve(res.data?.payload?.user);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const sendOtpCall = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/register-otp", data)
      .then((res) => {
        toastr.success(res?.data?.message);
        return resolve(res);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const refreshAuthCall = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // don't use axios API instance here
    axios
      .post(`${rootUrl.baseUrl}/v1/auth/refresh-tokens`, data)
      .then((res) => {
        const tokens = res.data.payload;

        dispatch(setCurrentUser(tokens.access));
        localStorage.setItem("accessToken", JSON.stringify(tokens.access));
        localStorage.setItem("refreshToken", JSON.stringify(tokens.refresh));

        return resolve(tokens?.access?.token);
      })
      .catch((err) => {
        if (
          err?.response?.data?.code === 401 &&
          err?.response?.data?.message === "Invalid refresh token"
        ) {
          dispatch(logoutCall());
        }
        // toastr.error(
        //   "Error",
        //   err?.response?.data?.message || "Please Login again"
        // );
        return reject(err);
      });
  });
};

const clearFeaturesData = () => (dispatch) => {
  dispatch(resetGroup());
  dispatch(resetStore());
  dispatch(resetCamps());
  dispatch(resetFbState());
  dispatch(resetLoyalty());
  dispatch(resetPayState());
  dispatch(resetCampState());
  dispatch(resetCustState());
  dispatch(resetVendorState());
  dispatch(resetProductTour());
  dispatch(resetOnboardState());
  dispatch(resetChannelState());
  dispatch(resetShortlinkState());
  dispatch(resetDashboardState());
  dispatch(resetAudienceRecState());
  dispatch(initalizeAutoCampState());
};

export const clearData = () => (dispatch) => {
  dispatch({
    type: RESET_AUTH_STATE,
  });
  dispatch(clearFeaturesData());
  localStorage?.removeItem("storeId");
  localStorage?.removeItem("accessToken");
  localStorage?.removeItem("refreshToken");
};

export const logoutCall = () => (dispatch) => {
  // window.analytics.track("Signed Out");
  resetAmplitude();
  window.rudderanalytics.reset();

  const refreshToken = getRefreshToken(true);

  if (refreshToken?.length > 0) {
    return new Promise((resolve, reject) => {
      Api.post("/v1/auth/logout", {
        refreshToken,
      })
        .then(() => {
          dispatch(clearData());
          return resolve(true);
        })
        .catch((err) => {
          dispatch(clearData());
          return reject(err);
        });
    });
  } else {
    dispatch(clearData());
  }
};

export const loginWithOtpCall = (data, prevCountryCode) => (dispatch) => {
  localStorage.clear();
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/login-mobile", data)
      .then((res) => {
        if (res.data.status === 200) {
          const { tokens, user } = res.data.payload;
          dispatch(setCurrentUser(tokens.access));
          dispatch(setInitialSignUpData(user));
          localStorage.setItem("accessToken", JSON.stringify(tokens.access));
          localStorage.setItem("refreshToken", JSON.stringify(tokens.refresh));

          return resolve(res.data?.payload?.user);
        } else if (res.data.status === 201) {
          dispatch(
            setInitialSignUpData({ ...data, country_code: prevCountryCode })
          );
          toastr.success(res?.data?.message);
          return resolve("OTP Sent");
        }
      })
      .catch((err) => {
        dispatch(
          setInitialSignUpData({ ...data, country_code: prevCountryCode })
        );
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const sendVerificationEmail = () => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/send-verification-email")
      .then(() => {
        toastr.success("Email Sent Successfully");
        return resolve(true);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};

export const verifyEmail = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/verify-email", data)
      .then(() => {
        return resolve(true);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};

export const forgotPassword = (data) => (dispatch) => {
  const isEmailMethod = data.method === "email";

  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/forgot-password", data)
      .then((res) => {
        if (isEmailMethod) {
          toastr.success(
            "Success",
            "Please check your mail, We've sent a reset password link to the provided email."
          );
        } else {
          dispatch(setInitialSignUpData(data));
          toastr.success("Success", "OTP sent to provided mobile number");
        }
        return resolve(res);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const resetPassword = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/auth/reset-password", data)
      .then((res) => {
        toastr.success("Success", "Password reset successfull");
        return resolve(res);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateUserCall = (data, isNameUpdate, isOtpCall) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.patch("/v1/users/me", data)
      .then((res) => {
        if (isOtpCall) {
          toastr.success("OTP sent successfully");
          return resolve(true);
        }

        let user = res?.data?.payload?.user;
        const tokens = res?.data?.payload?.tokens;

        dispatch({
          type: SET_USER_FRM_API,
          payload: user,
        });

        if (!isNameUpdate) {
          dispatch(setCurrentUser(tokens.access));
          localStorage.setItem("accessToken", JSON.stringify(tokens.access));
          localStorage.setItem("refreshToken", JSON.stringify(tokens.refresh));
        }

        return resolve(true);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error("Error", err?.response?.data?.message);
          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getBillingInfo = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get("/v1/users/billing")
      .then((res) => {
        dispatch({
          type: SET_BILLING_DETAILS,
          payload: res?.data?.payload?.billing_details,
        });

        return resolve(res?.data?.payload?.billing_details);
      })
      .catch((err) => {
        return reject(err?.response?.data?.message);
      });
  });
};

export const getStatesOfCountry = (countryCode) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/utility/country-codes?country_code=${countryCode}`)
      .then((res) => {
        const statesArr =
          res?.data?.payload?.data?.map((state) => state?.state) ?? [];

        dispatch({
          type: SET_STATES_OF_COUNTRY,
          payload: statesArr,
        });
        return resolve(statesArr);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const verifyResetPasswordToken = (data) => {
  return new Promise((resolve, reject) => {
    Api.post(`v1/auth/verify-reset-password-link`, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 401) {
          return resolve({ blacklisted: true });
        }

        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );
        return reject(err);
      });
  });
};
